import React from "react";
import './Fauna.css';
import Navbutton from "../navbutton/Navbutton";
import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import fundofolha from "../image/fundofolha.jpg";
import g1 from "./img/g1.jpg";
import g2 from "./img/g2.jpg";
import g3 from "./img/g3.jpg";
import g4 from "./img/g4.JPG";
import Header from "../components/Header";



const Drones = () => {
  
    const handleGoBack = () => {
      window.history.back(); // Volta à página anterior
    };

  return (
    <div className="fauna-container">
       <Header/>
    <div className="fauna-header">
      <h1> Drones e Geoprocessamento </h1>
      <p>Oferecemos uma ampla gama de serviços para promover a sustentabilidade e saúde de ambientes florestais.</p>
    </div>
    <div className="conteudo-grid">
      <div className="conteudo-card">
      <img
                src={g1}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                  
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
        <h3> Monitoramento com Drones</h3>
        <p>tilizamos drones com sensores avançados para fotografias e monitoramento de obras, plantios compensatórios, passivos ambientais e áreas de preservação permanente.
        </p>
      </div>
      <div className="conteudo-card">
      <img
                src={g2}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                  
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
        <h3> Mapeamento Aéreo
        </h3>
        <p> Realizamos mapeamentos precisos para análise de vegetação, topografia e uso do solo, identificando áreas degradadas e planejando ações de recuperação ambiental.
        </p>
      </div>
      <div className="conteudo-card">
      <img
                src={g3}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                 
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
        <h3> Gestão de Áreas Protegidas</h3>
        <p>Oferecemos monitoramento contínuo de áreas protegidas, delimitação de unidades de conservação e análises de corredores ecológicos e uso do solo.

</p>
      </div>
      <div className="conteudo-card">
      <img
                src={g4}
                alt="Laudo Técnico"
                style={{
                  width: "100%", // Largura total do card
                  
                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                }}
              />
        <h3> Geoprocessamento Avançado</h3>
        <p>Elaboramos mapas temáticos, análises espaciais, zoneamentos ambientais e estudos de impacto com ferramentas de geoprocessamento de última geração..</p>
      </div>
    </div>
    <div className="back-button-container">
    <button onClick={handleGoBack} className="back-button"   > <i class=" fas fa-solid fa-arrow-left"></i>
      Voltar
    </button>
  </div>
  <section class="footer" style={{
   background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    
    
    color: "#fff" // Para contrastar o texto com o fundo
  }}>
        <div class="box-container">
          <div class="box">
            <h3>Navegue</h3>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Início{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Sobre{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Serviços{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Equipe{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Iniciar conversa{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Avaliações{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Blog{" "}
            </a>
          </div>

          <div class="box">
            <h3>Nossos serviços</h3>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Florestal{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i>  Fauna{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Propriedade Intelectual{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Laudos e Pareceres Técnicos{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Levantamentos{" "}
            </a>
          </div>

          <div class="box">
            <h3>Contato </h3>
            <a href="#">
              {" "}
              <i class="fas fa-phone"></i> (34) 9 9920-3789{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-phone"></i> (11) 9 8632-1639{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-envelope"></i> emerson@biolinksolucoes.com.br{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais {" "}
            </a>
          </div>

          <div class="box">
            <h3>Conecte-se conosco!</h3>
            <a href="#">
              {" "}
              <i class="fab fa-facebook-f"></i> facebook{" "}
            </a>
          
            <a href="#">
              {" "}
              <i class="fab fa-instagram"></i> instagram{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fab fa-linkedin"></i> linkedin{" "}
            </a>
           
          </div>
        </div>

        <div class="credit">
          {" "}
          Criado por{" "}
          <span>
            <a href="https://instagram.com"> Biolink </a>
          </span>{" "}
          | ©Todos os direitos reservados.{" "}
        </div>
      </section>
  </div>
  );
};

export default Drones;